import React from "react";
import styled, { css } from "../../../styled-components";

import { CheckBox } from "../../../atoms/checkbox";

const Container = styled.div`
  display: inline-block;
`;
const HeaderContainer = styled.div`
  color: #373737;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 25px;
  margin-top: 5px;
`;

const DayColumn = styled.div<{ readonly day: string }>`
  /*  The "all" column */
  ${props =>
    props.day === "all" &&
    css`
      border-right: 1px solid #dddddd;
    `}
`;

const HourBox = styled.div<{
  readonly time: string;
  readonly rowIndex: number;
  readonly day: string;
}>`
  padding: 0px 5px 0px 15px;
  padding-top: 2px;

  /* The "all" row */
  ${props =>
    !parseInt(props.time) &&
    css`
      border-bottom: 1px solid #dddddd;
      padding-bottom: 5px;
      margin-bottom: 10px;
    `}

  /*  The "all" column content with hour text and checkbox  */
  ${props =>
    props.day === "all" &&
    parseInt(props.time) &&
    css`
      display: flex;
      justify-content: space-between;
      padding-right: 0;
      margin-left: 2px;

      &::before {
        content: "${props.time}";
        font-size: 12px;
        font-weight: bold;
        margin-right: 15px;
        line-height: 1.756;
      }
    `}

  /* row color */
  ${props =>
    props.rowIndex % 2 === 1 &&
    css`
      background-color: #f7f9fc;
    `}

  label {
    height: 21px;
  }
`;

const StyledLabel = styled.label`
  font-size: 13px;
  margin-left: 5px;
`;

export function HourPickerCard({
  hours,
  title,
  dayValue
}: {
  readonly title: string;
  readonly dayValue: string;
  readonly hours: ReadonlyArray<{
    readonly time: string;
    readonly isChecked: boolean;
    readonly disabled?: boolean;
    readonly onClick: () => void;
  }>;
}) {
  return (
    <Container>
      <HeaderContainer>{dayValue !== "all" && title}</HeaderContainer>
      <DayColumn day={dayValue}>
        {hours.map((h, index) => (
          <HourBox key={h.time} time={h.time} rowIndex={index} day={dayValue}>
            <CheckBox
              onClick={h.onClick}
              disabled={h.disabled}
              isChecked={h.isChecked}
              children={
                <StyledLabel>
                  {!parseInt(h.time) && dayValue === "all" && h.time}
                </StyledLabel>
              }
            />
          </HourBox>
        ))}
      </DayColumn>
    </Container>
  );
}
